import { useContext } from 'react';
import { FormTokenChainContext } from '../../context/FormTokenChainContext';

export const useFormTokenChainContext = () => {
  const context = useContext(FormTokenChainContext);

  if (context.isProvided === false) {
    throw new Error(
      'useFormTokenChainContext must be used within a FormTokenChainContextProvider'
    );
  }

  return context;
};
